import defaultLayout from '../../../layouts/default'

export default {
  path: 'note',
  component: defaultLayout,
  children: [
    {
      path: 'view',
      component: () => import('./view/note.vue'),
      meta: {
        activeMenu: 'note',
        auth: true
      }
    }
  ]
}
